export const HUBS_EN = {
    // ── the hub renderer ──
    'hub.export': 'Export',
    'hub.customize': 'Choose cards',
    'hub.customize.lede': 'Which figures and cards this page shows you. Kept for you in this browser; nobody else’s page changes.',
    'hub.customize.save': 'Save',
    'hub.section.tiles': 'Figures',
    'hub.section.cards': 'Cards',
    'hub.tabs': 'Kind',
    'hub.tile.unavailable': 'Not reachable right now',
    'hub.feed.all': 'All of it ({n})',
    'hub.feed.unavailable': 'Could not be read now: {parts}',
    'hub.feed.forbidden': 'Not shown, you have no access: {parts}',
    'hub.due.in': 'in {days}',
    'hub.due.since': '{days} ago',
    'hub.due.expired': 'Expired {days} ago',
    'hub.timeline.today': 'Today',
    'chart.today': 'Today',
    'hub.flag.staffing': 'Breaks the minimum staffing',
    'hub.flag.conflict': 'Conflicts',
    'hub.flag.clear': 'No conflict',
    'hub.flag.due': 'Due {due}',
    'hub.flag.overdue': 'Past its deadline',
    // ── the shell's hubs ──
    'hub.col.employee': 'Employee',
    'hub.col.subject': 'Subject',
    'hub.col.due': 'Due',
    'hub.col.date': 'Date',
    'hub.col.item': 'Item',
    'hub.desk.title': 'HR desk',
    'hub.desk.lede': '{today} · What needs acting on today, the soonest first',
    'hub.desk.decide': 'Needs your decision',
    'hub.desk.decide.empty': 'Nothing is waiting on a decision of yours.',
    'hub.desk.upcoming': 'Coming this week',
    'hub.desk.upcoming.empty': 'Nothing falls due this week.',
    'hub.expiries.title': 'Expiries and due dates',
    'hub.expiries.lede': 'Everything that runs out for an employee in one place, with the step it calls for',
    'hub.expiries.view.list': 'List',
    'hub.expiries.view.timeline': 'Timeline',
    'hub.expiries.range': 'Range',
    'hub.expiries.range.30': '30 days',
    'hub.expiries.range.60': '60 days',
    'hub.expiries.range.90': '90 days',
    'hub.expiries.range.180': '180 days',
    'hub.expiries.b.expired': 'Expired',
    'hub.expiries.b.expired.detail': 'Needs acting on today',
    'hub.expiries.b.d30': 'Within 30 days',
    'hub.expiries.b.d60': '31 – 60 days',
    'hub.expiries.b.d90': '61 – 90 days',
    'hub.expiries.timeline': 'The next three months',
    'hub.expiries.list': 'The list',
    'hub.expiries.col.what': 'What runs out',
    'hub.expiries.col.left': 'Left',
    'hub.expiries.col.needed': 'What it needs',
    'hub.expiries.empty': 'Nothing runs out in this range.',
    'hub.kind.iqama': 'Iqama',
    'hub.kind.passport': 'Passport',
    'hub.kind.contract': 'Contract',
    'hub.kind.probation': 'Probation',
    'hub.kind.medical': 'Medical insurance',
    'hub.kind.license': 'Professional licence',
    'hub.approvals.title': 'Waiting for my approval',
    'hub.approvals.lede': 'Every request you may decide, from every module, the oldest first',
    'hub.approvals.col.requester': 'Requester',
    'hub.approvals.col.summary': 'Summary',
    'hub.approvals.col.since': 'Waiting',
    'hub.approvals.col.flag': 'Note',
    'hub.approvals.col.type': 'Type',
    'hub.approvals.empty': 'Nothing is waiting for your decision.',
    "unit.hub_joiners.zero": "{n} start work",
    "unit.hub_joiners.one": "{n} starts work",
    "unit.hub_joiners.two": "{n} start work",
    "unit.hub_joiners.few": "{n} start work",
    "unit.hub_joiners.many": "{n} start work",
    "unit.hub_joiners.other": "{n} start work",
    "unit.hub_departments.zero": "{n} departments",
    "unit.hub_departments.one": "{n} department",
    "unit.hub_departments.two": "{n} departments",
    "unit.hub_departments.few": "{n} departments",
    "unit.hub_departments.many": "{n} departments",
    "unit.hub_departments.other": "{n} departments",
    "gov_sa.gosi.hub.desk_pending.title": "Social insurance items pending",
    "gov_sa.gosi.hub.desk_pending.detail": "{register} registration · {wage_update} wage update · {exclude} exclusion",
    "gov_sa.gosi.hub.col.pending": "Pending",
    "gov_sa.gosi.hub.col.register": "Registrations",
    "gov_sa.gosi.hub.col.wage_update": "Wage updates",
    "gov_sa.gosi.hub.col.exclude": "Exclusions",
    "hub.col.employment_id": "Employment",
    "hub.col.employee_detail": "Where they work",
    "hub.col.party_id": "Person",
    "hub.col.kind": "Kind",
    "hub.col.record_status": "Record",
    "hub.col.leave_type_name": "Leave type",
    "hub.col.from_on": "From",
    "hub.col.to_on": "To",
    "hub.col.roster": "At work",
    "hub.col.last_read": "Last reading",
    "hub.col.silent_device": "Device",
    "hub.col.device_note": "Devices",
    "hub.col.silent_since": "Silent since",
    "hub.col.unrecorded": "Not recorded yet",
    "hub.col.coverage_note": "Today's record",
    "hub.col.next_count_on": "On",
    "hub.col.name": "Name",
    "hub.col.open": "Not complete",
    "hub.col.what": "What",
    "hub.col.on": "Date",
    "hub.col.reason": "Reason",
    "hub.col.people": "People",
    "hub.col.requester": "Requester",
    "hub.col.summary": "Summary",
    "hub.col.since": "Waiting since",
    "hub.col.flag": "Note",
    "hub.col.days": "Days",
    "hub.col.balance_after": "Balance after",
    "hub.col.overlap_count": "Away from the team",
    "hub.col.status": "Status",
    "hub.col.requester_detail": "Where they work",
    "hub.col.type": "Type",
    "hub.col.number_last4": "Number",
    "hub.col.type_name": "Document",
    "forms.hub.inbox.title": "Forms",
    "forms.hub.inbox.one": "Form",
    "forms.hub.inbox.summary": "{summary} · {step}",
    "forms.hub.col.step": "Step",
    "forms.hub.col.number": "No.",
    "forms.hub.col.due_at": "Decide by",
    "forms.hub.action.approve": "Approve",
    "forms.hub.action.reject": "Refuse",
    "forms.hub.action.open": "Open the request",
    "forms.hub.field.reason": "Why",
    "hub.flag.probation": "Probation ends soon",
    "hub.flag.deadline": "Its last day is near",
    "hub.approvals.chosen": "{n} chosen",
    "hub.approvals.approve_chosen": "Approve the chosen",
    "hub.approvals.refuse_chosen": "Refuse with a reason",
    "hub.approvals.outcome": "Done: {done} · refused by their module: {failed} · to open on their own: {skipped}",
    "hub.approvals.choose_all": "Choose every request",
    "hub.approvals.choose": "Choose the request of {who}",
    "hub.approvals.action_for": "{action}: {who}",
    "hub.approvals.read_one": "Read the request of {who}",
    "hub.approvals.count": "{n} · the oldest first",
    "hub.approvals.refuse_title": "Refuse the chosen requests",
    "hub.approvals.refuse_lede": "The reason is what each requester reads. A request its module decides otherwise is opened on its own.",
    "hub.approvals.reason": "Why",
    "hub.approvals.no_earlier": "No earlier request.",
    "unit.hours.one": "{n} hour",
    "unit.hours.two": "{n} hours",
    "unit.hours.few": "{n} hours",
    "unit.hours.many": "{n} hours",
    "unit.hours.other": "{n} hours",
    "unit.hours.zero": "{n} hours",
    "unit.hub_requests.zero": "No requests",
    "unit.hub_requests.one": "{n} request",
    "unit.hub_requests.two": "{n} requests",
    "unit.hub_requests.few": "{n} requests",
    "unit.hub_requests.many": "{n} requests",
    "unit.hub_requests.other": "{n} requests",
    "hub.col.flag_tone": "Tone",
    "hub.col.can_decide": "May decide",
    "hub.col.can_rate": "May rate",
    "hub.col.can_approve": "May approve",
    "hub.col.version": "Version",
    "documents.hub.desk_expiring.title": "Documents running out",
    "documents.hub.desk_expiring.label": "Documents running out within 30 days",
    "documents.hub.col.expiring": "Within 30 days",
    "documents.hub.col.expired": "Expired",
    "documents.hub.col.top_type": "Mostly",
    "documents.hub.col.top_count": "Of them",
    "documents.hub.desk_decide.title": "Documents",
    "documents.hub.subject": "{type_name} {state}",
    "documents.hub.state.expired": "has expired",
    "documents.hub.state.expiring": "runs out",
    "documents.hub.what": "{type_name} •••• {number_last4}",
    "documents.hub.needed": "Renew the {type_name}",
    "documents.hub.action.renew": "Record the renewal",
    "hub.col.state": "State",
    "documents.hub.desk_expiring.detail": "{expired} expired · {top_count} {top_type}",
    'nav.hub.desk': 'HR desk',
    'nav.hub.finance': 'Finance desk',
    // ── the finance desk ──
    'hub.finance.title': 'Finance desk',
    'hub.finance.lede': '{today} · What needs acting on today, the soonest first',
    'hub.finance.branch': 'Branch',
    'hub.finance.decide': 'Needs your decision',
    'hub.finance.decide.empty': 'Nothing is waiting on a decision of yours.',
    'hub.finance.upcoming': 'Due this week',
    'hub.finance.upcoming.empty': 'Nothing falls due this week.',
    'hub.finance.col.subject': 'What',
    'hub.finance.col.party': 'With whom',
    'hub.finance.col.amount': 'Amount',
    'hub.finance.col.since': 'Waiting',
    'nav.hub.expiries': 'Expiries and due dates',
    'nav.hub.approvals': 'Waiting for my approval',
    'nav.module.hub': 'Human resources',
    // ── workforce analytics (hub.analytics) and the parts employees, offboarding, attendance and payroll attach to it ──
    'hub.analytics.title': 'Workforce analytics',
    'hub.analytics.lede': 'Counted on the server from the records, up to {today}',
    'hub.analytics.period': 'Period',
    'hub.analytics.period.3': 'Last 3 months',
    'hub.analytics.period.6': 'Last 6 months',
    'hub.analytics.period.12': 'Last 12 months',
    'hub.analytics.branch': 'Branch',
    'hub.analytics.department': 'Department',
    'hub.tile.forbidden': 'You have no permission',
    'nav.hub.analytics': 'Analytics',
    'nav.hub.integrations': 'Connections',
    'hub.integrations.title': 'Connections',
    'hub.integrations.lede': 'This company\'s accounts with the authorities and providers. Whatever the company has not set up runs on the operator\'s setup where there is one, and its card says so.',
    'hub.integrations.staff': 'Reaching employees',
    'hub.integrations.government': 'Government bodies',
    'hub.integrations.files': 'Files and banks',
    'unit.percent.other': '{n}%',
    'unit.permille.other': '{n}‰',
    'unit.leavers.one': '{n} leaver',
    'unit.leavers.other': '{n} leavers',
    'unit.leavers.zero': '{n} leavers',
    'unit.leavers.two': '{n} leavers',
    'unit.leavers.few': '{n} leavers',
    'unit.leavers.many': '{n} leavers',
};
export const HUBS_AR = {
    // ── the hub renderer ──
    'hub.export': 'تصدير',
    'hub.customize': 'تخصيص البطاقات',
    'hub.customize.lede': 'ما يعرضه لك هذا المكتب من أرقام وبطاقات. يُحفظ لك في هذا المتصفح، ولا تتغيّر صفحة أحد غيرك.',
    'hub.customize.save': 'حفظ',
    'hub.section.tiles': 'الأرقام',
    'hub.section.cards': 'البطاقات',
    'hub.tabs': 'النوع',
    'hub.tile.unavailable': 'تعذّر الوصول الآن',
    'hub.feed.all': 'كل ما ينتظرك ({n})',
    'hub.feed.unavailable': 'تعذّرت قراءتها الآن: {parts}',
    'hub.feed.forbidden': 'لا تظهر لأنك لا تملك صلاحيتها: {parts}',
    'hub.due.in': 'بعد {days}',
    'hub.due.since': 'منذ {days}',
    'hub.due.expired': 'منتهية منذ {days}',
    'hub.timeline.today': 'اليوم',
    'chart.today': 'اليوم',
    'hub.flag.staffing': 'يتعارض مع الحد الأدنى',
    'hub.flag.conflict': 'يتعارض',
    'hub.flag.clear': 'لا تعارض',
    'hub.flag.due': 'يستحق {due}',
    'hub.flag.overdue': 'تجاوز المدة',
    // ── the shell's hubs ──
    'hub.col.employee': 'الموظّف',
    'hub.col.subject': 'الموضوع',
    'hub.col.due': 'الموعد',
    'hub.col.date': 'التاريخ',
    'hub.col.item': 'البند',
    'hub.desk.title': 'مكتب الموارد البشرية',
    'hub.desk.lede': '{today} · ما يحتاج تصرفاً اليوم، مرتباً بالأقرب موعداً',
    'hub.desk.decide': 'يحتاج قراراً منك',
    'hub.desk.decide.empty': 'لا شيء ينتظر قراراً منك.',
    'hub.desk.upcoming': 'قادم هذا الأسبوع',
    'hub.desk.upcoming.empty': 'لا شيء يحلّ موعده هذا الأسبوع.',
    'hub.expiries.title': 'الانتهاءات والمواعيد',
    'hub.expiries.lede': 'كل ما ينتهي لموظّف في مكان واحد، مع الإجراء الذي يلزمه',
    'hub.expiries.view.list': 'قائمة',
    'hub.expiries.view.timeline': 'خط زمني',
    'hub.expiries.range': 'المدى',
    'hub.expiries.range.30': '30 يوماً',
    'hub.expiries.range.60': '60 يوماً',
    'hub.expiries.range.90': '90 يوماً',
    'hub.expiries.range.180': '180 يوماً',
    'hub.expiries.b.expired': 'منتهية',
    'hub.expiries.b.expired.detail': 'تحتاج تصرفاً اليوم',
    'hub.expiries.b.d30': 'خلال 30 يوماً',
    'hub.expiries.b.d60': '31 – 60 يوماً',
    'hub.expiries.b.d90': '61 – 90 يوماً',
    'hub.expiries.timeline': 'الأشهر الثلاثة القادمة',
    'hub.expiries.list': 'القائمة',
    'hub.expiries.col.what': 'ما ينتهي',
    'hub.expiries.col.left': 'المتبقي',
    'hub.expiries.col.needed': 'ما يلزم',
    'hub.expiries.empty': 'لا شيء ينتهي في هذا المدى.',
    'hub.kind.iqama': 'إقامة',
    'hub.kind.passport': 'جواز سفر',
    'hub.kind.contract': 'عقد',
    'hub.kind.probation': 'فترة تجربة',
    'hub.kind.medical': 'تأمين طبي',
    'hub.kind.license': 'رخصة مهنية',
    'hub.approvals.title': 'ما ينتظر اعتمادي',
    'hub.approvals.lede': 'كل طلب لك أن تقرّر فيه، من كل المديولات، الأقدم أولاً',
    'hub.approvals.col.requester': 'الطالب',
    'hub.approvals.col.summary': 'الملخص',
    'hub.approvals.col.since': 'منذ',
    'hub.approvals.col.flag': 'ملاحظة',
    'hub.approvals.col.type': 'النوع',
    'hub.approvals.empty': 'لا شيء ينتظر قرارك.',
    "unit.hub_joiners.zero": "{n} يباشرون العمل",
    "unit.hub_joiners.one": "موظّف يباشر العمل",
    "unit.hub_joiners.two": "موظّفان يباشران العمل",
    "unit.hub_joiners.few": "{n} يباشرون العمل",
    "unit.hub_joiners.many": "{n} يباشرون العمل",
    "unit.hub_joiners.other": "{n} يباشرون العمل",
    "unit.hub_departments.zero": "{n} إدارة",
    "unit.hub_departments.one": "إدارة واحدة",
    "unit.hub_departments.two": "إدارتين",
    "unit.hub_departments.few": "{n} إدارات",
    "unit.hub_departments.many": "{n} إدارة",
    "unit.hub_departments.other": "{n} إدارة",
    "gov_sa.gosi.hub.desk_pending.title": "بنود التأمينات المعلّقة",
    "gov_sa.gosi.hub.desk_pending.detail": "{register} تسجيل · {wage_update} تحديث أجر · {exclude} استبعاد",
    "gov_sa.gosi.hub.col.pending": "معلّقة",
    "gov_sa.gosi.hub.col.register": "تسجيل",
    "gov_sa.gosi.hub.col.wage_update": "تحديث أجر",
    "gov_sa.gosi.hub.col.exclude": "استبعاد",
    "hub.col.employment_id": "التوظيف",
    "hub.col.employee_detail": "مكان العمل",
    "hub.col.party_id": "الشخص",
    "hub.col.kind": "النوع",
    "hub.col.record_status": "السجل",
    "hub.col.leave_type_name": "نوع الإجازة",
    "hub.col.from_on": "من",
    "hub.col.to_on": "إلى",
    "hub.col.roster": "على رأس العمل",
    "hub.col.last_read": "آخر قراءة",
    "hub.col.silent_device": "الجهاز",
    "hub.col.device_note": "الأجهزة",
    "hub.col.silent_since": "صامت منذ",
    "hub.col.unrecorded": "لم يُسجَّل بعد",
    "hub.col.coverage_note": "تسجيل اليوم",
    "hub.col.next_count_on": "في",
    "hub.col.name": "الاسم",
    "hub.col.open": "لم تكتمل",
    "hub.col.what": "ما هو",
    "hub.col.on": "التاريخ",
    "hub.col.reason": "السبب",
    "hub.col.people": "العدد",
    "hub.col.requester": "الطالب",
    "hub.col.summary": "الملخص",
    "hub.col.since": "منذ",
    "hub.col.flag": "ملاحظة",
    "hub.col.days": "الأيام",
    "hub.col.balance_after": "الرصيد بعدها",
    "hub.col.overlap_count": "غائبون من الفريق",
    "hub.col.status": "الحالة",
    "hub.col.requester_detail": "مكان العمل",
    "hub.col.type": "النوع",
    "hub.col.number_last4": "الرقم",
    "hub.col.type_name": "الوثيقة",
    "forms.hub.inbox.title": "نماذج",
    "forms.hub.inbox.one": "نموذج",
    "forms.hub.inbox.summary": "{summary} · {step}",
    "forms.hub.col.step": "الخطوة",
    "forms.hub.col.number": "الرقم",
    "forms.hub.col.due_at": "يُقرَّر قبل",
    "forms.hub.action.approve": "اعتماد",
    "forms.hub.action.reject": "رفض",
    "forms.hub.action.open": "افتح الطلب",
    "forms.hub.field.reason": "السبب",
    "hub.flag.probation": "التجربة تنتهي قريباً",
    "hub.flag.deadline": "آخر يوم للقرار قريب",
    "hub.approvals.chosen": "{n} محددة",
    "hub.approvals.approve_chosen": "اعتماد المحدد",
    "hub.approvals.refuse_chosen": "رفض مع سبب",
    "hub.approvals.outcome": "تم: {done} · رفضها مديولها: {failed} · تُفتح وحدها: {skipped}",
    "hub.approvals.choose_all": "تحديد الكل",
    "hub.approvals.choose": "اختيار طلب {who}",
    "hub.approvals.action_for": "{action}: {who}",
    "hub.approvals.read_one": "قراءة طلب {who}",
    "hub.approvals.count": "{n} · الأقدم أولاً",
    "hub.approvals.refuse_title": "رفض الطلبات المحددة",
    "hub.approvals.refuse_lede": "السبب هو ما يقرؤه كل طالب. الطلب الذي يُقرَّر في مديوله بغير ذلك يُفتح وحده.",
    "hub.approvals.reason": "السبب",
    "hub.approvals.no_earlier": "لا طلبات سابقة.",
    "unit.hours.zero": "{n} ساعة",
    "unit.hours.one": "ساعة",
    "unit.hours.two": "ساعتين",
    "unit.hours.few": "{n} ساعات",
    "unit.hours.many": "{n} ساعة",
    "unit.hours.other": "{n} ساعة",
    "unit.hub_requests.zero": "لا طلبات",
    "unit.hub_requests.one": "طلب واحد",
    "unit.hub_requests.two": "طلبان",
    "unit.hub_requests.few": "{n} طلبات",
    "unit.hub_requests.many": "{n} طلباً",
    "unit.hub_requests.other": "{n} طلب",
    "hub.col.flag_tone": "اللون",
    "hub.col.can_decide": "له أن يقرر",
    "hub.col.can_rate": "له أن يقيّم",
    "hub.col.can_approve": "له أن يعتمد",
    "hub.col.version": "الإصدار",
    "documents.hub.desk_expiring.title": "وثائق تنتهي",
    "documents.hub.desk_expiring.label": "وثائق تنتهي خلال 30 يوماً",
    "documents.hub.col.expiring": "خلال 30 يوماً",
    "documents.hub.col.expired": "منتهية",
    "documents.hub.col.top_type": "أكثرها",
    "documents.hub.col.top_count": "منها",
    "documents.hub.desk_decide.title": "الوثائق",
    "documents.hub.subject": "{type_name} {state}",
    "documents.hub.state.expired": "منتهية",
    "documents.hub.state.expiring": "تنتهي",
    "documents.hub.what": "{type_name} •••• {number_last4}",
    "documents.hub.needed": "تجديد {type_name}",
    "documents.hub.action.renew": "تسجيل التجديد",
    "hub.col.state": "الحالة",
    "documents.hub.desk_expiring.detail": "{expired} منتهية · {top_count} {top_type}",
    'nav.hub.desk': 'مكتب الموارد البشرية',
    'nav.hub.finance': 'مكتب المالية',
    // ── مكتب المالية ──
    'hub.finance.title': 'مكتب المالية',
    'hub.finance.lede': '{today} · ما يحتاج عملاً اليوم، الأقرب أولاً',
    'hub.finance.branch': 'الفرع',
    'hub.finance.decide': 'يحتاج قرارك',
    'hub.finance.decide.empty': 'لا شيء ينتظر قراراً منك.',
    'hub.finance.upcoming': 'يستحق هذا الأسبوع',
    'hub.finance.upcoming.empty': 'لا شيء يستحق هذا الأسبوع.',
    'hub.finance.col.subject': 'ماذا',
    'hub.finance.col.party': 'مع من',
    'hub.finance.col.amount': 'المبلغ',
    'hub.finance.col.since': 'منذ',
    'nav.hub.expiries': 'الانتهاءات والمواعيد',
    'nav.hub.approvals': 'ما ينتظر اعتمادي',
    'nav.module.hub': 'الموارد البشرية',
    // ── workforce analytics (hub.analytics) and the parts employees, offboarding, attendance and payroll attach to it ──
    'hub.analytics.title': 'تحليلات القوى العاملة',
    'hub.analytics.lede': 'محسوبة في الخادم من السجلات حتى {today}',
    'hub.analytics.period': 'الفترة',
    'hub.analytics.period.3': 'آخر 3 أشهر',
    'hub.analytics.period.6': 'آخر 6 أشهر',
    'hub.analytics.period.12': 'آخر 12 شهراً',
    'hub.analytics.branch': 'الفرع',
    'hub.analytics.department': 'الإدارة',
    'hub.tile.forbidden': 'لا تملك صلاحية',
    'nav.hub.analytics': 'التحليلات',
    'nav.hub.integrations': 'الربط',
    'hub.integrations.title': 'الربط',
    'hub.integrations.lede': 'حسابات هذه الشركة لدى الجهات والمزوّدين. ما لم تضبطه الشركة يعمل بإعداد المشغّل إن وُجد، ويُكتب ذلك على بطاقته.',
    'hub.integrations.staff': 'التواصل مع الموظّفين',
    'hub.integrations.government': 'الجهات الحكومية',
    'hub.integrations.files': 'الملفات والبنوك',
    'unit.percent.other': '{n}%',
    'unit.permille.other': '{n}‰',
    'unit.leavers.one': 'مغادر واحد',
    'unit.leavers.other': '{n} مغادر',
    'unit.leavers.zero': 'لا مغادرين',
    'unit.leavers.two': 'مغادران',
    'unit.leavers.few': '{n} مغادرين',
    'unit.leavers.many': '{n} مغادراً',
};
//# sourceMappingURL=i18n-hubs.js.map